import { render, staticRenderFns } from "./canyuDetail.vue?vue&type=template&id=644eb28e&scoped=true"
import script from "./canyuDetail.vue?vue&type=script&lang=js"
export * from "./canyuDetail.vue?vue&type=script&lang=js"
import style0 from "./canyuDetail.vue?vue&type=style&index=0&id=644eb28e&prod&lang=less"
import style1 from "./canyuDetail.vue?vue&type=style&index=1&id=644eb28e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644eb28e",
  null
  
)

export default component.exports